import { DataProvider } from 'react-admin';
import { httpClient } from '../httpClient';

// @ts-expect-error not yet all functions
export const categoriesDataProvider: DataProvider = {
  getOne: async (resource, params) => {
    const [categoriesList] = await Promise.all([
      httpClient('/categories', { method: 'GET' }),
    ]);

    const categoriesData = categoriesList.json.find(
      ({ id }: { id: string }) => params.id === id,
    );

    return {
      data: categoriesData,
    };
  },

  getMany: async () => {
    const [categoriesList] = await Promise.all([
      httpClient('/categories', { method: 'GET' }),
    ]);

    return {
      data: categoriesList.json.map((category: any) => category),
      // TODO: needs to come from the server
      total: categoriesList.json.length,
    };
  },

  getList: async (_, params) => {
    const offset = (params.pagination.page - 1) * params.pagination.perPage;

    const [categoriesList] = await Promise.all([
      httpClient('/categories', { method: 'GET' }),
    ]);

    return {
      data: categoriesList.json.map((category: any) => category),
      // TODO: needs to come from the server, but since it doesn't, we simulate hte logic of it lol
      total:
        categoriesList.json.length === params.pagination.perPage
          ? params.pagination.page * params.pagination.perPage + 1
          : offset + categoriesList.json.length,
    };
  },

  deleteMany: async (_, params) => {
    return await Promise.all(
      params.ids.map((value) =>
        httpClient(`/categories/${value}`, {
          method: 'DELETE',
          ...params,
        }),
      ),
    ).then(() => ({ data: [] }));
  },

  delete: async (_, params) => {
    return await httpClient(`/categories/${params.id}`, {
      method: 'DELETE',
    }).then(({ json }) => ({ data: json }));
  },

  update: async (_, params) => {
    const body = JSON.stringify({ ...params.data });

    await httpClient(`/categories/${params.id}`, {
      method: 'PATCH',
      body,
    });

    return {
      data: { id: params.id } as any,
    };
  },

  create: async (_, params) => {
    const body = JSON.stringify({ ...params.data });

    const { json } = await httpClient(`/categories`, {
      method: 'POST',
      body,
    });

    return {
      data: json,
    };
  },
};
